var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-3"},[_c('v-layout',[_c('inventory',{attrs:{"positioning":_vm.positioning}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }